// import { Grid, Stack, Typography, useMediaQuery } from "@mui/material";
// import ContactForm from "../components/contactComponents/contactForm";
// import { useState } from "react";
// import headerConstants from "../utils/headerConstant.json";
// import importantEmails from "../utils/importantEmails.json";
// import Tables from "../components/Tables";
// interface InfoProps {
//   phone: number;
//   email1: string;
//   email2: string;
//   email3: string;
//   address: string;
// }

// const ContactUs = () => {
//   const [headers, setHeaders] = useState<InfoProps>(headerConstants.headers);
//   const titles = ["Name", "Email Id's"];
//   const isSmallScreen = useMediaQuery("(max-width:899px)");
//   return (
//     <Grid
//       container
//       sx={{ backgroundColor: "primary.light", p: { xs: 1, md: 3 } }}
//       columns={{ xs: 1, md: 2 }}
//     >
//       <Grid item xs={1} md={0.8}>
//         <Stack
//           direction={"column"}
//           alignItems={{ xs: "center", md: "flex-start" }}
//           justifyContent={"space-around"}
//           spacing={2}
//           width={"90%"}
//           height={"90%"}
//           sx={{ margin: "auto" }}
//         >
//           <ContactForm />
//         </Stack>
//       </Grid>
//       <Grid item xs={1} md={1.2}>
//         <Grid container columns={{ xs: 1, md: 2 }}>
//           <Grid item xs={1}>
//             <Stack direction={"column"} p={2}>
//               <Typography variant="h5">Address</Typography>
//               <Typography fontSize={14} variant="body2" textAlign={"justify"}>
//                 {headers.address}
//               </Typography>
//             </Stack>
//           </Grid>
//           <Grid item xs={1}>
//             <Stack direction={"column"} p={2}>
//               <Typography variant="h5">Email</Typography>
//               <Typography
//                 fontSize={14}
//                 variant="body2"
//                 textAlign={"justify"}
//                 mb={2}
//               >
//                 {headers.email1}
//               </Typography>
//               <Typography variant="h5">Phone</Typography>
//               <Typography fontSize={14} variant="body2" textAlign={"justify"}>
//                 +91 {headers.phone}
//               </Typography>
//             </Stack>
//           </Grid>
//         </Grid>
//         <iframe
//           title="Maps"
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.083866206272!2d73.8456119751918!3d18.525111882569238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c07c23fbcfc3%3A0x8175088f4f3b4571!2sModern%20College%20of%20Physiotherapy!5e0!3m2!1sen!2sin!4v1716527813679!5m2!1sen!2sin"
//           width="95%"
//           style={{
//             minHeight: `${isSmallScreen ? "500px" : "75%"}`,
//             margin: "1rem",
//           }}
//         ></iframe>
//         {/* Importat Emails */}
//         {/* <Tables titles={titles} data={importantEmails} /> */}
//       </Grid>
//     </Grid>
//   );
// };

// export default ContactUs;






import {
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  Paper,
  Box,
  Divider,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import ContactForm from "../components/contactComponents/contactForm";
import { useState } from "react";
import headerConstants from "../utils/headerConstant.json";
import importantEmails from "../utils/importantEmails.json";
import Tables from "../components/Tables";

interface InfoProps {
  phone: number;
  email1: string;
  email2: string;
  email3: string;
  address: string;
}

interface InfoRowProps {
  icon: React.ReactNode;
  label: string;
  value: string;
}

const InfoRow = ({ icon, label, value }: InfoRowProps) => (
  <Stack direction="row" spacing={1.5} alignItems="flex-start">
    <Box sx={{ color: "#1a3a6b", mt: "2px", opacity: 1 }}>{icon}</Box>
    <Typography
      fontSize={14}
      fontWeight={600}
      sx={{ lineHeight: 1.6, color: "#1a1a1a", opacity: 1 }}
    >
      <Box component="span" sx={{ color: "#0d1b33" }}>
        {label}
      </Box>{" "}
      – {value}
    </Typography>
  </Stack>
);

const ContactUs = () => {
  const [headers, setHeaders] = useState<InfoProps>(headerConstants.headers);
  const titles = ["Name", "Email Id's"];
  const isSmallScreen = useMediaQuery("(max-width:899px)");

  return (
    <Grid
      container
      sx={{ backgroundColor: "primary.light", p: { xs: 1, md: 3 } }}
      columns={{ xs: 1, md: 2 }}
      spacing={{ xs: 2, md: 3 }}
    >
      <Grid item xs={1} md={0.8}>
        <Stack
          direction={"column"}
          alignItems={{ xs: "center", md: "flex-start" }}
          justifyContent={"space-around"}
          spacing={2}
          width={"90%"}
          height={"90%"}
          sx={{ margin: "auto" }}
        >
          <ContactForm />
        </Stack>
      </Grid>

      <Grid item xs={1} md={1.2}>
        <Stack spacing={2.5}>
          {/* Admission process contact info - English & Marathi */}
          <Paper
            elevation={2}
            sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 3,
              backgroundColor: "#ffffff",
            }}
          >
            <Stack spacing={1.75}>
              <InfoRow
                icon={<SchoolIcon fontSize="small" />}
                label="COLLEGE NAME"
                value="PES MODERN COLLEGE OF PHYSIOTHERAPY"
              />
              <InfoRow
                icon={<LocationOnIcon fontSize="small" />}
                label="COLLEGE ADDRESS"
                value="P.E.S.W.I.E Sports Complex, Modern College Road, Shivaji Nagar Pune- 411005"
              />
              <InfoRow
                icon={<PhoneIcon fontSize="small" />}
                label="WORKING TELEPHONE NUMBER FOR ADMISSION PROCESS"
                value="9922007316"
              />
              <InfoRow
                icon={<WhatsAppIcon fontSize="small" />}
                label="COLLEGE WHATSAPP NUMBER"
                value="9922007316"
              />
              <InfoRow
                icon={<EmailIcon fontSize="small" />}
                label="OFFICIAL EMAIL ID"
                value="pespune5@yahoo.co.in, pesmodernphysiotherapy@gmail.com"
              />
              <InfoRow
                icon={<PersonIcon fontSize="small" />}
                label="ADMISSION PROCESS CONTACT"
                value="Dr. Priti Patil (Associate Professor) – 9960084284"
              />

              <Divider sx={{ my: 0.5 }} />

              <InfoRow
                icon={<SchoolIcon fontSize="small" />}
                label="महाविद्यालयाचे नाव"
                value="पी.ई.एस. मॉडर्न कॉलेज ऑफ फिजिओथेरपी"
              />
              <InfoRow
                icon={<LocationOnIcon fontSize="small" />}
                label="महाविद्यालयाचा पत्ता"
                value="पी.ई.एस.डब्ल्यू.आय.ई. (P.E.S.W.I.E) स्पोर्ट्स कॉम्प्लेक्स, मॉडर्न कॉलेज रोड, शिवाजी नगर, पुणे - ४११००५"
              />
              <InfoRow
                icon={<PhoneIcon fontSize="small" />}
                label="प्रवेश प्रक्रियेसाठी कार्यरत दूरध्वनी क्रमांक"
                value="९९२२००७३१६"
              />
              <InfoRow
                icon={<WhatsAppIcon fontSize="small" />}
                label="महाविद्यालयाचा व्हॉट्सॲप क्रमांक"
                value="९९२२००७३१६"
              />
              <InfoRow
                icon={<EmailIcon fontSize="small" />}
                label="अधिकृत ईमेल आयडी"
                value="pespune5@yahoo.co.in, pesmodernphysiotherapy@gmail.com"
              />
              <InfoRow
                icon={<PersonIcon fontSize="small" />}
                label="प्रवेश प्रक्रिया संपर्क"
                value="डॉ. प्रीती पाटील (सहयोगी प्राध्यापक) – ९९६००८४२८४"
              />
            </Stack>
          </Paper>

          {/* Map */}
          <Box
            sx={{
              width: "100%",
              height: isSmallScreen ? 260 : 320,
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: 1,
            }}
          >
            <iframe
              title="Maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.083866206272!2d73.8456119751918!3d18.525111882569238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c07c23fbcfc3%3A0x8175088f4f3b4571!2sModern%20College%20of%20Physiotherapy!5e0!3m2!1sen!2sin!4v1716527813679!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, display: "block" }}
            ></iframe>
          </Box>

          {/* Importat Emails */}
          {/* <Tables titles={titles} data={importantEmails} /> */}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ContactUs;